// Generation-guarded scheduler for restartable UI sessions. Reset both clears
// pending callbacks and invalidates a callback already queued by the browser.

export interface TimerHost {
  setTimeout(fn: () => void, ms: number): number;
  clearTimeout(id: number): void;
}

export class RunTimers {
  private generation = 0;
  private pending = new Set<number>();
  private stopped = false;

  constructor(private readonly host: TimerHost) {}

  after(ms: number, fn: () => void): void {
    if (this.stopped) return;
    const generation = this.generation;
    const id = this.host.setTimeout(() => {
      this.pending.delete(id);
      if (!this.stopped && generation === this.generation) fn();
    }, ms);
    this.pending.add(id);
  }

  reset(): void {
    this.generation++;
    for (const id of this.pending) this.host.clearTimeout(id);
    this.pending.clear();
  }

  destroy(): void {
    this.reset();
    this.stopped = true;
  }

  get size(): number {
    return this.pending.size;
  }
}
